type DeliveredIconProps = {
  className?: string;
  fill?: string;
};

export const DeliveredIcon = ({
  className = "",
  fill = "#fff",
}: DeliveredIconProps): React.ReactElement => (
  <svg
    fill={"#000"}
    className={`${className} text-black`}
    xmlns="http://www.w3.org/2000/svg"
    width="23.641"
    height="25"
    viewBox="0 0 23.641 25"
  >
    <g
      id="Group_6546"
      data-name="Group 6546"
      transform="translate(-26.64 -358)"
    >
      <g
        id="Group_6510"
        data-name="Group 6510"
        transform="translate(10263 23173)"
      >
        <rect
          id="Rectangle_1997"
          data-name="Rectangle 1997"
          width="21"
          height="24"
          rx="2"
          transform="translate(-10236.36 -22814)"
          fill={fill}
        />
        <g
          id="Rectangle_1998"
          data-name="Rectangle 1998"
          transform="translate(-10229.36 -22815)"
          fill={fill}
          stroke="#000"
          strokeWidth="1"
        >
          <rect width="8" height="7" stroke="none" />
          <rect x="0.5" y="0.5" width="7" height="6" fill="none" />
        </g>
        <path
          id="Path_2819"
          data-name="Path 2819"
          d="M31.155,18.356l-9.66,9.66a1.38,1.38,0,0,1-1.951,0l-4.14-4.14a1.38,1.38,0,1,1,1.951-1.951l3.164,3.164L29.205,16.4a1.38,1.38,0,1,1,1.951,1.951Z"
          transform="translate(-10244.28 -22818.42)"
        />
      </g>
      <g id="Group_6511" data-name="Group 6511" transform="translate(-0.86 2)">
        <line
          id="Line_366"
          data-name="Line 366"
          x2="14.671"
          transform="translate(30.5 367)"
          fill="none"
          stroke="#000"
          strokeWidth="1"
        />
        <path
          id="Path_2820"
          data-name="Path 2820"
          d="M0,0H14.671"
          transform="translate(30.5 370.5)"
          fill="none"
          stroke="#000"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);
